import React, { useContext } from 'react';
import { Host } from '../types';
const _context = React.createContext(null);
export const HostProvider = (props) => {
    const host = new Host(props);
    return React.createElement(_context.Provider, { value: host }, props.children);
};
export const useHost = () => {
    const context = useContext(_context);
    if (context == null)
        throw new Error('No es posible acceder al proveedor de Host, verifique que el componente esté dentro del proveedor <HostProvider />');
    return context;
};
